import styled from 'styled-components';

import { COLORS } from '@/nova/theme/tokens';
import { Text } from '@/nova/components';

export const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 12px;
  padding: 40px 24px;
`;

export const IconRing = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 52px;
  border-radius: 999px;
  background: ${COLORS.surfaceMuted};
`;

export const Title = styled(Text)`
  font-size: 16px;
  font-weight: 600;
  color: ${COLORS.heading};
`;

export const Body = styled(Text)`
  font-size: 13px;
  line-height: 1.5;
  max-width: 380px;
  color: ${COLORS.textMuted};
`;

export const Action = styled.div`
  margin-top: 4px;
`;
